import SVPageMeta from '@apps/www/src/www/containers/SVPageMeta';
import SVWithUserPage, {
	type Props as SVWithUserPageProps,
} from '@apps/www/src/www/containers/SVWithUserPage';
import SVBoardsList from '@pkgs/shared-client/components/SVBoardsList';
import SVPageMargins from '@pkgs/shared-client/components/SVPageMargins';

const _SVFeedUserBoardsPage = ({ user }: SVWithUserPageProps) => {
	const meta = {
		title: `Boards – ${user.name}`,
	};

	return (
		<>
			<SVPageMeta {...meta} />

			<SVPageMargins>
				<SVBoardsList showTitles={true} boards={user.boards} />
			</SVPageMargins>
		</>
	);
};

const SVFeedUserBoardsPage = SVWithUserPage(_SVFeedUserBoardsPage);

// @ts-ignore fix this
SVFeedUserBoardsPage.withUserHeader = true;
// @ts-ignore fix this
SVFeedUserBoardsPage.withUserSideMenu = true;

export default SVFeedUserBoardsPage;
